import { GRAY_SWATCH } from '../utils/color-palette.util';

export const DefaultValues = {
  highlightedElementOpacity: 0.5,
  /**
   * MAP-1017: opacity used to render (a) non-matching links when the link
   * display mode's "other links" choice is DIMMED rather than hidden, (b)
   * excluded-from-state elements in custom states, and (c) filtered-out
   * elements where filters are implemented (v2). Configurable in the
   * settings dialog Appearance section, range [0.1, 0.5]. 0.5 by default.
   */
  filteringOpacity: 0.5,
  weightMultiplier: 0.8,
  brightnessMultiplier: 3,
  ghostLinkSourceColor: 'rgba(0,0,0,0.5)',
  ghostLinkTargetColor: 'rgba(0,0,0,0.5)',
  doubleTapDelay: 350,
  appearance: {
    default: 'system',
    smap: 'default'
  },
  map: {
    styles: {
      backgroundSoundUrl: undefined,
      backgroundSoundVolume: 0.5
    }
  },
  node: {
    containerDarken: 1,
    nodeOverlayOpacity: 0.5,
    nodeDropOverlayOpacity: 0.3,
    nodeDragOpacity: 0.3,
    nodeHighlightColor: '#000000',
    containerOpacity: 0,
    color: GRAY_SWATCH,
    borderColor: '#000000',
    type: 'ELLIPSE',
    hasBorder: true,
    collapsed: false,
    weight: 2, // Default display value will be 4 with multiplier
    x: 0,
    y: 0,
    properties: {
      expanded: true,
      label: 'name',
      textFontColor: '#000000',
      textHalign: 'center',
      textValign: 'bottom',
      textMarginY: 1,
      textMarginX: 0,
      textRotation: 0,
      imageOpacity: 1,
      imageScale: 1,
      opacity: 0.1,
      colorOpacity: 0.8,
      textFontSize: 10,
      borderStyle: 'solid',
      scale: 3, // Default display value will be 6 with multiplier
      soundUrl: undefined,
      padding: 10,
      height: null as number | null
    }
  },
  link: {
    color: GRAY_SWATCH,
    label: 'name',
    type: 'BEZIER',
    direction: 'directed',
    opacity: 1,
    shape: 'solid',
    textFontSize: 8,
    textMarginY: 5,
    textMarginX: 5,
    labelOffset: 5,
    weight: 1, // Default display value will be 2 with multiplier
    selectedOverlayOpacity: 0.08,
    selectedOverlayColor: '#000000',
    edgeArrowType: 'triangle',
    soundUrl: undefined,
    labelSlope: 'sloped',
    linkLabelOffset: 4,
    newLinkType: 'ARCHED'
  },
  user: {
    color: GRAY_SWATCH
  },
  overlayElement: {
    width: 100,
    height: 100,
    rotation: 0,
    type: 'RECTANGLE',
    properties: {
      opacity: 1,
      backgroundColor: '#d3d3d3',
      borderColor: '#000000',
      borderWidth: 2,
      borderStyle: 'solid',
      zIndex: 0
    }
  }
}
